import { createContext } from 'react';
import { PaymentProfilesInterpreter } from '../machines';

type ContextState = {
  subscriptionCurrency: string | null;
  paymentProfilesService: PaymentProfilesInterpreter;
};
export const PaymentProfilesContext = createContext<ContextState>({
  paymentProfilesService: null,
  subscriptionCurrency: null,
} as ContextState);
